<template>
  <ThemeProvider theme="campsite">
    <div class="cs-overlay">
      <div class="cs-overlay__content">
        <div class="cs-overlay__logo">
          <Logo color="primary" :size="60" only-mark />
        </div>
        <VText class="cs-overlay__title" component="h1" variant="h3"
          >The page you're looking for doesn't exist.</VText
        >

        <div class="cs-overlay__actions" v-if="isValidUsername">
          Want this to be your Campsite.bio username?
          <InlineLink
            :href="`https://app.campsite.bio/create-account?username=${username}`"
          >
            Create your account
          </InlineLink>
        </div>
        <div class="cs-overlay__actions" v-else>
          <InlineLink to="/"> Return to homepage </InlineLink>
        </div>
      </div>
    </div>
  </ThemeProvider>
</template>

<script>
import {
  ThemeProvider,
  Logo,
  InlineLink,
  VText,
} from '@campsite-bio/component-lib';

import { computed, useRoute } from '@nuxtjs/composition-api';

import defaultOG from '@/assets/default-og';

export default {
  props: ['error'],

  layout: null,

  head() {
    return {
      title: `${
        this.error.statusCode === 404 ? 'Page Not Found' : 'Server Error'
      } - Campsite.bio`,
      meta: [...defaultOG],
    };
  },

  components: {
    ThemeProvider,
    Logo,
    InlineLink,
    VText,
  },

  setup() {
    const route = useRoute();

    const username = computed(() => route.value.path.split('/')[1]);

    const isValidUsername = computed(() => {
      const username = route.value.path.slice(1);
      const regex =
        /^[A-Za-z0-9_](?![_])(?!.*[_]{2})(?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,30}(?:[A-Za-z0-9_]))$/i;
      return regex.test(username);
    });

    return {
      isValidUsername,
      username,
    };
  },
};
</script>

<style lang="scss" scoped>
.cs-overlay {
  background: var(--g-color-bg);
  color: var(--g-color-on-bg);
  font: 400 18px/1.4 var(--g-font-body-family);
  display: flex;
  min-height: 50vh;
  place-content: center space-between;
  flex-direction: column;
  margin-left: -0.925rem;
  margin-right: -0.925rem;
  padding: 0 0.925rem;
  text-align: center;
  align-items: center;

  &__content {
    margin-top: 5rem;
    max-width: 600px;
    width: 92%;
  }

  &__logo {
    margin-bottom: 1.5rem;
  }

  &__actions {
    font-size: 1rem;
    margin-top: 2rem;
  }
}

.cs-overlay__title.cs-overlay__title {
  margin-bottom: 1rem;
}
</style>
